import { render, staticRenderFns } from "./PersonInfo.vue?vue&type=template&id=a631996a&scoped=true"
import script from "./PersonInfo.vue?vue&type=script&lang=js"
export * from "./PersonInfo.vue?vue&type=script&lang=js"
import style0 from "./PersonInfo.vue?vue&type=style&index=0&id=a631996a&prod&lang=scss&scoped=true"
import style1 from "./PersonInfo.vue?vue&type=style&index=1&id=a631996a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a631996a",
  null
  
)

export default component.exports